export const getShown = <K>(data: K[]): K[] => data
        .filter((d: K) => (d as Record<string, unknown>).isShown);

